// Use relative path for Genesis theme tests
import './assets/css/fonts.css';

// Typography: Set the font family and fallbacks

export const fonts = {
  headings: `Poppins, BlinkMacSystemFont, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif`,
  body: `Roboto, BlinkMacSystemFont, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif`,
};
